import { createContext, useContext, type ReactNode } from 'react'

export type CustomerLeftSidebarSlotValue = {
  title?: string
  content: ReactNode | null
}

type CustomerLeftSidebarSlotApi = {
  setLeftSidebar: (next: CustomerLeftSidebarSlotValue) => void
  clearLeftSidebar: () => void
}

const CustomerLeftSidebarSlotContext = createContext<CustomerLeftSidebarSlotApi | null>(null)

export function CustomerLeftSidebarSlotProvider({
  value,
  children,
}: {
  value: CustomerLeftSidebarSlotApi
  children: ReactNode
}) {
  return (
    <CustomerLeftSidebarSlotContext.Provider value={value}>
      {children}
    </CustomerLeftSidebarSlotContext.Provider>
  )
}

export function useCustomerLeftSidebarSlot() {
  const ctx = useContext(CustomerLeftSidebarSlotContext)
  if (!ctx) throw new Error('useCustomerLeftSidebarSlot must be used within CustomerLeftSidebarSlotProvider')
  return ctx
}

